"use strict";

exports.__esModule = true;
exports.default = void 0;
/**
 * Check string only has spaces
 * 
 * @param {String} value string value
 * @returns {Boolean} value has spaces
 */
var hasOnlySpaces = function hasOnlySpaces(value) {
  if (typeof value !== 'string') return false;
  if (!value) return false;
  var trimedValue = value.trim();
  if (!trimedValue) return true;
  return false;
};
var _default = exports.default = hasOnlySpaces;